// src/features/products/supplierApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const supplierApi = createApi({
  reducerPath: 'supplierApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.supplier.get }),
  tagTypes: ['supplierApi'],
  endpoints: (builder) => ({
    getSuppliers: builder.query({
      query: () => "getSuppliers",
      keepUnusedDataFor: 35,
      providesTags: ['supplierApi'],
      invalidatesTags: ['supplierApi'],
    }),
    createSupplier: builder.mutation({
      query: (supplier) => {
        const formData = new FormData();
        Object.entries(supplier).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.supplier.post,
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => {
       
        return response
      },
      invalidatesTags: ['supplierApi'], 
    }),
    updateSupplier: builder.mutation({
      query: (supplierData) => {
        const formData = new FormData();
        Object.entries(supplierData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.supplier.update + supplierData.Id,
          method: 'PUT',
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['supplierApi'],
    }),
    deleteSupplier: builder.mutation({
      query: (id) => ({
        url: Urls.supplier.delete + id,
        method: 'DELETE',
      }),
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['supplierApi'],
    }),
  }),
  keepUnusedDataFor: 1,
  // keepUnusedDataFor: 10 * 60 * 1000,
  // staleTime: 5 * 60 * 1000,
  // cacheTime: 60 * 1000,
});
export const {
  useGetSuppliersQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
} = supplierApi;
